var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('label',{class:_vm.hidden ? 'hidden' : '',style:(_vm.styles)},[_c('input',{attrs:{"name":"file","type":"file","accept":_vm.accept,"multiple":"false"},on:{"change":_vm.handleFile}}),_vm._v(" "+_vm._s(_vm.label)+" ")])}
var staticRenderFns = []

export { render, staticRenderFns }